<div
  role="dialog"
  class="td-wb-confirm-dialog"
  aria-labelledby="td-wb-aria-confirm-dialog-title"
  aria-describedby="td-wb-aria-confirm-dialog-desc">
  <h2 id="td-wb-aria-confirm-dialog-title">
    <ng-content select="td-wb-confirm-title" />
  </h2>
  <div id="td-wb-aria-confirm-dialog-desc">
    <ng-content select="td-wb-confirm-body" />
    <ng-content select="td-wb-confirm-buttons" />
  </div>
</div>
